window.$(function(){
    window.$('[data-toggle="tooltip"]').tooltip();
window.$(".side-nav .collapse").on("hide.bs.collapse", function() {                   
    window.$(this).prev().find(".fa").eq(1).removeClass("fa-angle-right").addClass("fa-angle-down");
    });
    window.$('.side-nav .collapse').on("show.bs.collapse", function() {                        
        window.$(this).prev().find(".fa").eq(1).removeClass("fa-angle-down").addClass("fa-angle-right");        
    });

});
 
    